<template>
    <div>

        <DxForm ref="formInstance" :form-data="model">
            <DxGroupItem>
                <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />
                <DxItem data-field="Nombre" editor-type="dxTextBox" :editorOptions="{ 'maxLength': '200' }"
                    :col-span="3" :disabled="true">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.nombre')" />
                    <DxRequiredRule
                        :message="$t('instalaciones.popup_guardar_instalacion.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="NombreInstalacionTipo" editor-type="dxTextBox"
                    :editorOptions="{ 'maxLength': '200' }" :col-span="3" :disabled="true">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.nombre_instalacion_tipo')" />
                    <DxRequiredRule :message="$t('zonas.popup_guardar_zona.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="NombreProvincia" editor-type="dxTextBox" :editorOptions="{ 'maxLength': '200' }"
                    :col-span="3" :disabled="true">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.nombre_provincia')" />
                    <DxRequiredRule :message="$t('zonas.popup_guardar_zona.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="NombreComunidadAutonoma" editor-type="dxTextBox"
                    :editorOptions="{ 'maxLength': '200' }" :col-span="3" :disabled="true">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.nombre_comunidad_autonoma')" />
                    <DxRequiredRule :message="$t('zonas.popup_guardar_zona.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="IdZona" editor-type="dxSelectBox" :editor-options="zonaEditorOptions" :col-span="6">
                    <DxLabel :text="$t('instalaciones.popup_guardar_instalacion.id_zona')" />
                    <DxRequiredRule
                        :message="$t('instalaciones.popup_guardar_instalacion.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="Latitud" editor-type="dxTextBox" :editorOptions="{ 'maxLength': '200' }"
                    :col-span="3">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.latitud')" />
                    <DxRequiredRule
                        :message="$t('instalaciones.popup_guardar_instalacion.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="Longitud" editor-type="dxTextBox" :editorOptions="{ 'maxLength': '200' }"
                    :col-span="3">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.longitud')" />
                    <DxRequiredRule
                        :message="$t('instalaciones.popup_guardar_instalacion.mensaje_validacion_obligatorio')" />
                </DxItem>
            </DxGroupItem>
        </DxForm>
    </div>
</template>

<script setup lang="ts">
import { DxForm } from "devextreme-vue";
import { useIntl } from '@services/i18n';
import { useApi } from '@/.shared/.api/integration';
import type { EditInstalacionModalModel } from "./Model";
import { DxRequiredRule } from "devextreme-vue/data-grid";
import type { EditInstalacionModel } from '@/.shared/.api';
import { computed, getCurrentInstance, onMounted, ref, } from 'vue';
import { useModalBuilder } from '@/.shared/helpers/modal-building-helper';
import { validateDxFormAsync } from '@/.shared/helpers/dxvalidation-helper';
import { toastSuccess, toastError } from '@/.shared/services/notification-service';
import { DxGroupItem, DxItem, DxLabel, DxColCountByScreen, DxAsyncRule } from "devextreme-vue/form";

const props = defineProps<{ instalacionProp: EditInstalacionModalModel }>();
const editing = computed(() => props.instalacionProp != null);
const model = computed(() => (editing.value) ? props.instalacionProp : {} as EditInstalacionModalModel);
const idInstalacion = computed(() => (!editing.value) ? undefined : (model.value as EditInstalacionModalModel).Id);

const api = useApi();
const intl = useIntl();
const modalBuilder = useModalBuilder();

const formInstance = ref<DxForm>();
const zonaEditorOptions = ref<any>(
    {
        displayExpr: "Nombre",
        valueExpr: "Id",
        searchEnabled: "true"
        // onValueChanged: tipoComunicadoChanged
    });

onMounted(async () => {
    modalBuilder.setContext(getCurrentInstance()!);

    let botones = modalBuilder.standardButtons.addOkCancel();
    botones.okButton.update((b) => {
        b.text = intl.i18n.t("zonas.popup_guardar_zona.boton_anadir_zona")
        b.onClick = async () => {
            const result = await validateDxFormAsync(formInstance.value!.instance!);
            if (result.isValid) {
                if (editing.value) {
                    const editInstalacionModel: EditInstalacionModel = {
                        Id: model.value!.Id,
                        Nombre: model.value!.Nombre,
                        Latitud: model.value!.Latitud,
                        Longitud: model.value!.Longitud,
                        IdZona: model.value!.IdZona
                    };
                    await api.callStandardApi("instalacionEdit", { showLoading: true }, editInstalacionModel);
                    toastSuccess(intl.i18n.t('instalaciones.popup_guardar_instalacion.mensaje_instalacion_editada'));
                }
                modalBuilder.close(true);
            } else {
                toastError(intl.i18n.t('instalaciones.popup_guardar_instalacion.mensaje_validacion_no_superada'));
            }
        }
    });

    botones.cancelButton.update((b) => {
        b.onClick = async () => {
            // const result = await modalService.messageBox('¿Está seguro de que desea cancelar?', 'Confirmación', 'yesNo', 'warning');
            //      if (result === 'yes')
            modalBuilder.close(false);
        }
    });

    await rellenarZonas();
});

async function rellenarZonas(): Promise<void> {
    const data = await api.callStandardApi("zonaGetTodas", { showLoading: true });
    zonaEditorOptions.value = { ...zonaEditorOptions, dataSource: data };
}
</script>